import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Download } from 'lucide-react';

const OrderPreviewDialog = ({
  open,
  onClose,
  previewUrl,
  previewTitle,
  onDownload
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl max-h-[90vh]" data-testid="pdf-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>{previewTitle}</span>
            <div className="flex items-center space-x-2">
              <Button variant="outline" size="sm" onClick={onDownload} data-testid="download-from-preview-btn">
                <Download className="w-4 h-4 mr-2" />
                Download
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="w-full h-[70vh] border rounded-lg overflow-hidden bg-muted/20">
          {previewUrl && (
            <iframe
              src={previewUrl}
              className="w-full h-full"
              title={previewTitle}
              data-testid="pdf-preview-iframe"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { OrderPreviewDialog };
